import { Avatar, UserIcon } from '@eventbrite/marmalade';
import React from 'react';
import styles from './OrganizerInfo.module.scss';

/**
 * Organizer avatar + name line.
 *
 * Port notes vs eb-ui `OrganizerInfo.tsx`:
 * - `eds-avatar` `Avatar` → Marmalade `Avatar` (the catalog's verified swap; no
 *   `legacy-eds.avatar` bridge exists). eds `AvatarSize.xsmall` = **32px**
 *   (eds-iconography `iconography_sizes.json`); Marmalade's `size="small"` is
 *   the 32px slot (its default `medium` is 40px) — see the catalog's size-trap
 *   note (eds and Marmalade size NAMES shift by one).
 * - eds `iconType={<User />}` (eds-iconography) → Marmalade `icon={<UserIcon />}`.
 * - `GenericLazyString` (lazy i18n) is gone — `name` is a plain string.
 */
export interface OrganizerInfoType {
    name: string;
    imageUrl?: string;
}

interface OrganizerInfoProps {
    organizer?: OrganizerInfoType;
}

export const OrganizerInfo: React.FunctionComponent<OrganizerInfoProps> = (
    props,
) => {
    const { organizer } = props;

    if (!props.organizer) {
        return null;
    }

    const organizerAvatarProps = organizer?.imageUrl
        ? { imageSrc: organizer?.imageUrl, imageAlt: '' }
        : { icon: <UserIcon /> };

    return (
        <div
            className={styles.organizerInfo}
            data-testid="collection-card--organizer-info"
        >
            <Avatar size="small" {...organizerAvatarProps} />
            <span className={styles.organizerName}>{organizer?.name}</span>
        </div>
    );
};
